import { reports as actionTypes } from '$constants/action-types';

export const fetchAll = params => ({
  type: actionTypes.FETCH_ALL,
  params
});

export const fetchAllRequest = () => ({
  type: actionTypes.FETCH_ALL_REQUEST
});

export const fetchAllSuccess = (result, hasMore) => ({
  type: actionTypes.FETCH_ALL_SUCCESS,
  result,
  hasMore
});

export const fetchAllFailure = errors => ({
  type: actionTypes.FETCH_ALL_FAILURE,
  errors
});



// WEBPACK FOOTER //
// ./src/actions/reports.js